import UserRepository from "../../ports/userRepository";
import { User } from "../../../entities/user";

export type addUserUseCase = (user: User) => Promise<any>

export const buildUser = (dependencies: { 
 userRepo: UserRepository 
}): addUserUseCase => {
  const { userRepo } = dependencies;

  const addUser: addUserUseCase = async (user: User) =>
    userRepo.addUser(user);

  return addUser;
}